import {
  DELETE_EF_LICENSE_API,
  GET_IS_MANAGEMENT_LICENSED_API,
  IMPORT_EF_LICENSE_API,
  SEARCH_EF_LICENSES_API
} from '~/constants/APIs'
import {
  IEFLicenseSearchForm,
  IEFLicenseSearchResponse,
  IEFManagementLicense
} from '~/models'
import axiosClient from './axiosClient'
export const efLienceApis = {
  searchOtapAgents: (params: IEFLicenseSearchForm | null) =>
    axiosClient.get(SEARCH_EF_LICENSES_API, {
      params
    }) as unknown as IEFLicenseSearchResponse,
  importOtapAgent: (data: File[]) => {
    const formData = new FormData()
    data.forEach(item => formData.append('formFiles', item))
    return axiosClient.post(IMPORT_EF_LICENSE_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteOtapAgent: (featureCode: any) =>
    axiosClient.delete(DELETE_EF_LICENSE_API + featureCode),

  getIsManagementLicensed: () =>
    axiosClient.get(GET_IS_MANAGEMENT_LICENSED_API) as unknown as IEFManagementLicense
}
